import { sortDirections } from '@adalo/constants'

export const applySort = (data, sort) => {
  if (!sort || !Array.isArray(data)) {
    return data
  }

  let { fieldId, direction } = sort

  let bias = direction === sortDirections.ASC ? 1 : -1

  return data.slice().sort((a, b) => {
    if (a.id === b.id) {
      return 0
    }

    let valueA = a[fieldId]
    let valueB = b[fieldId]

    if (typeof valueA === 'string') {
      valueA = valueA.toLowerCase()
    }
    if (typeof valueB === 'string') {
      valueB = valueB.toLowerCase()
    }

    let value = valueA > valueB ? 1 : -1

    return bias * value
  })
}
